import { AxiosInstance } from 'axios';

import { COMPANY_URLS } from '@/constants/urls';

class CompanyApi {
  axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getCompanyContact(companyId: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.axiosInstance
        .get(`${COMPANY_URLS.GET_CONTACT}?company=${companyId}`)
        .then(response => {
          resolve(response.data);
        })
        .catch((error: any) => {
          reject(error?.response?.data?.detail);
        });
    });
  }
}

export default CompanyApi;
